(function () {
  const redirectList = [
    "/blogs/corporate-projects/amrapali",
    "/blogs/stoneart-blogs/discover-the-soul-of-stone-timeless-craftsmanship-at-stone-art",
    "/blogs/stoneart-blogs/best-type-of-planters-know-how-to-use-inside-or-outside-of-your-home",
    "/product/exquisite-antique-gate-arch-marble-with-inlay/",
    "/product/il-43/",
    "/product/sa-189/",
    "/product/gs-39/",
    "/product/historic-samundar-manthan-stone-wall-panel/",
    "/product/bl-561/",
    "/product/ga-19/",
    "/product/bl-656/",
    "/product/pl-86/",
    "/product/sw-85/",
    "/product-category/planters/page/2/",
    "/product/bali-stone-turtle/",
    "/product/bl-157/",
    "/product/onyx-marble-lady-statue-with-planter/",
    "/product/vietnam-marble-wildlife-wall-panel/",
    "/product/sb-26/",
    "/product/bali-stone-bamboo-blossom-carved-small-wall-panel/",
    "/product/bl-518/",
    "/product/fn-50/",
    "/product/sw-224/",
    "/product/tp-ms-7/",
    "/product/bronze-brahma-sculpture/",
    "/product/lj-11/",
    "/product/sw-227/",
    "/product/onyx-marble-bathroom-accessories-set/",
    "/collections/pebble",
    "/collections/devi-ji",
    "/collections/tier",
    "/collections/brackets",
    "/collections/jharokhas",
    "/product-category/temples/page/4/",
    "/blogs", // you can add more here...
  ];

  const currentPath = window.location.pathname.toLowerCase();

  if (redirectList.includes(currentPath)) {
    window.location.href = "/";
  }
})();


<!-- Canonical Fix for /collections/ceramic -->

  (function () {
    const path = window.location.pathname.toLowerCase();
    if (path === "/collections/ceramic") {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://stoneart.asia/collections/ceramic");
      document.head.appendChild(canonicalLink);
    }
  })();


  // Get the current path of the URL
  const currentPath = window.location.pathname;

  if (currentPath === "/collections" || currentPath === "/collections/") {
    window.location.replace("/collections/all");
  }


  // Redirect from /collections/jharokhas to /collections/jharokas
  if (window.location.pathname === "/collections/jharokhas") {
    window.location.replace("/collections/jharokas");
  }

// Redirect from /collections/jharokhas to /collections/jharokas
  if (window.location.pathname === "/blogs") {
    window.location.replace("/blogs/stoneart-blogs");
  }

// Redirect from /collections/jharokhas to /collections/jharokas
  if (window.location.pathname === "/collections/devi-ji") {
    window.location.replace("/collections/devi-ji-hindu-gods");
  }

